import React  , { useState } from "react";
import { Col, Modal, ModalBody, Row ,ModalHeader, Label} from "reactstrap"
import {  AvForm, AvField } from "availity-reactstrap-validation";

import {  useDispatch, connect, useSelector} from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";

import { comprasUpdate, comprasList} from '../../../store/compras/actions'


export const EditCompraModal = ({
    EditCompras,
    onCloseClick,
    compraDetalle,
    
}) => {

    const dispatch= useDispatch();
    const handleButtonClick = () => {
        onCloseClick(); // Llama a la función onCloseClick pasada como prop desde el componente padre
      
      };

      const state = useSelector(state=>state.Compras) || []
      const id = Number(compraDetalle && compraDetalle ? compraDetalle.id :null)
      
      
      const [comprobante, setFormDataCotizacion] = useState([]);

      const handleComprobanteChange = (evCotizacion) => {
       Array.from(evCotizacion).forEach((comprobante) => {
         var reader = new FileReader();
         reader.readAsDataURL(comprobante);
         reader.onload = function () {
           var img = [];
           var base64 = reader.result;
           img = base64.split(",");
           setFormDataCotizacion(img[1] );
         };
       });
     };



    

      const [formData, setFormData] =  useState({
        valor_pagado:"",
        observaciones:"",
      
     
       
      })
      const {
        valor_pagado,
        observaciones
        
       
        
      } = formData
    
      const onChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value})
      }
    

      const onSubmit = (e) => {
        e.preventDefault();
      
        const data = {
          estado_compra: "pagado",
          valor_pagado,
          observaciones,
        };
      
        if (comprobante.length > 0) {
          data.comprobante = comprobante;
        }
      
        console.log(data);
        dispatch(comprasUpdate(id, data));
      };
      
      


console.log(comprobante)


console.log(state)
      
       
    return ( 

        <React.Fragment>

{state.comprasUpdated.id ? (
              <SweetAlert
                title="Hecho!"
                success
                timeout={2000}
                showConfirm={false}
                onConfirm={() => {
                  onCloseClick()
                  dispatch(comprasList())
                }}
              >
                Se ha Editado la compra
              </SweetAlert>
            ) : null}


        <Modal isOpen={EditCompras} toggle={onCloseClick} centered={true} >
         <ModalHeader toggle={handleButtonClick} tag="h4">
             Compra
                 
         </ModalHeader>

         <ModalBody>
         <AvForm  
                                   onSubmit={onSubmit}
                                   >
                                  
                                  
                                        <Row className="col-lg-12 justify-content-center">
                                            <Col lg={8} className="mb-10">
                                              <Label
                                                for="informe_visita"
                                                className="col-form-label col-sm-4 d-flex"
                                              >
                                            <strong>VALOR</strong> 
                                              </Label>
                                              <input
                                                className="form-control"
                                                id="valor_pagado"
                                                name="valor_pagado"
                                                type="text"
                                               
                                                onChange={onChange}
                                          
                                             
                                              
                                                
                                                
                                              />
                                              </Col>
                                              </Row>
                                  
                                        <Row className="col-lg-12 justify-content-center">
                                            <Col lg={8} className="mb-10">
                                              <Label
                                                for="informe_visita"
                                                className="col-form-label col-sm-4 d-flex"
                                              >
                                            <strong>OBSERVACIONES</strong> 
                                              </Label>
                                              <textarea
                                                className="form-control"
                                                id="observaciones"
                                                name="observaciones"
                                                type="text"
                                                required={true}
                                                onChange={onChange}
                                                // value={cargo_persona_recibe_servicio}
                                             
                                              
                                                
                                                
                                              />
                                              </Col>
                                              </Row>
                                        <Row className="col-lg-12 justify-content-center">
                                            <Col lg={8} className="mb-10">
                                              <Label
                                                for="informe_visita"
                                                className="col-form-label col-sm-8 d-flex"
                                              >
                                            <strong>COMPROBANTE DE COMPRA</strong> 
                                              </Label>
                                              <AvField
                                                    className="form-control"
                                                    id="valor"
                                                    name="valor"
                                                    type="file"
                                                    required
                                                    onChange={(e) => handleComprobanteChange(e.target.files)}
                                                    errorMessage="Por favor, selecciona un archivo válido."
                                                  />

                                                  {/* {props.error && props.error.valor_pagar ? (
                      <Alert color = 'danger' className="mt-2">{props.error.valor_pagar}</Alert>
                    ):null} */}
                                              </Col>
                                              </Row>

                                                 {/* Botones de abajo */}
                            <Row>
                              <Col>
                                <div className="text-end">
                                  <button
                                    type="button"
                                    className="btn btn-light me-2"
                                    onClick={handleButtonClick}
                                  >
                                    Cerrar 
                                  </button>
                                 
                                  <button
                                    type="submit"
                                    className="btn btn-success save-event"
                                   
                                  
                                  >
                                    Guardar
                                  </button>
                                </div>
                              </Col>
                            </Row>
                                              </AvForm>
                                              
       


         </ModalBody>
         </Modal>
         </React.Fragment>
     );
}
 
const mapStateToProps = (state) => {
  const { error, loading, comprasUpdated } = state.Compras;
  return { error, loading, comprasUpdated };
  };
  
  EditCompraModal.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  comprasUpdated: PropTypes.object,
  };
  export default withRouter(connect(mapStateToProps, { comprasUpdate })(EditCompraModal));